export default __webpack_public_path__ + "static/SanFranciscoText-Bold-7f17b8f5fd8481079ed235d8a20b9c36.woff2";